import styled from 'styled-components';

import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {useCommunityReportReasons} from "../../../api/report_reasons";
import {useSaveClicked} from "../../../store";
import useModal from "../../../modals";
import React, {useEffect, useState} from "react";
import Sheet from "../../../components/bottom-sheet/sheet";
import AddRuleSheet from "../../../components/bottom-sheet/mod/add_rule";

const Item = styled.div``;

const RulesCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();
    const [time, setTime] = useState(Date.now());
    const rules = useCommunityReportReasons(feedbackCh, community, time)?.rules;

    const saveClicked = useSaveClicked();
    const modal = useModal();
    const [addRuleOpen, setAddRuleOpen] = useState(false);
    const [currentRule, setCurrentRule] = useState(false);

    useEffect(() => {
        (async () => {
            if (saveClicked && rules) {
                setCurrentRule(-1);
                setAddRuleOpen(true);
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    const handleEdit = (i) => {
        setCurrentRule(i);
        setAddRuleOpen(true);
    };

    const handleClose = () => {
        setAddRuleOpen(false);
        setTime(Date.now());
    };

    return (
        <>
            <FixedTopBar back title="Community Rules" border={false} save={'Add'}/>
            <WhiteMain className={className}>
                {rules?.map((rule, i) =>
                    // eslint-disable-next-line react/no-array-index-key
                    <Item key={rule} onClick={() => handleEdit(i)}>
                        {rule}
                    </Item>
                )}
            </WhiteMain>
            {addRuleOpen && <Sheet onClose={() => handleClose() } padding={"header"}><AddRuleSheet community={community} communityRules={rules} i={currentRule} onClose={() => handleClose() } /></Sheet>}
        </>
    );
})`
  ${Item} {
    color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : 'inherit'};
    font-weight: 600;
    padding: 12px 24px;
    font-size: 16px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
  }
`;

export default RulesCommunitySettings;
